import { Component, OnInit, Input, Output, EventEmitter, OnChanges, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { FormDefinition } from '../../models/dynamic-form.interfaces';
import { DynamicFormBuilderService } from '../../services/dynamic-form-builder.service';
@Component({
  selector: 'mojo-dynamic-form',
  templateUrl: './dynamic-form.component.html',
})
export class DynamicFormComponent implements OnInit, OnChanges, OnDestroy {

  @Input() formDefinition: FormDefinition;
  @Input() displaySaveButton = true;
  @Input() displayCreateCopyButton = true;
  @Input() displayCancelButton = true;
  @Input() displayDeleteButton = true;
  @Input() displayResetAllUsersButton = false;
  @Output() onCancel = new EventEmitter<any>();
  @Output() onSave = new EventEmitter<any>();
  @Output() onCreateCopy = new EventEmitter<any>();
  @Output() onDelete = new EventEmitter<any>();
  @Output() onResetAllUsersToDefaultColumns = new EventEmitter<any>();

  isAlive = true;
  form: UntypedFormGroup;
  loading$: Observable<boolean>;

  constructor(
    private dynamicFormBuilderService: DynamicFormBuilderService
  ) { }

  ngOnInit() {

  }

  ngOnChanges() {
    if (this.formDefinition) {
      this.form = this.dynamicFormBuilderService.buildForm(this.formDefinition);
    } else {
      this.form = undefined;
    }
  }

  ngOnDestroy() {
    this.isAlive = false;
  }

  submit() {
    this.onSave.emit(this.form.value);
  }
  cancel() {
    this.onCancel.emit();
  }
  createCopy() {
    this.onCreateCopy.emit(this.form.value);
  }
  delete() {
    this.onDelete.emit(this.form.value);
  }

  resetAllUsersToDefaultColumns() {
    this.onResetAllUsersToDefaultColumns.emit(this.form);
  }

  documentCategoryShowAllChecked(field) {
    return field.value.every(r => r.Show);
  }

  documentCategoryAllowUploadAllChecked(field) {
    return field.value.every(r => r.AllowUpload);
  }

  handleDocumentCategoryShowAllChange(evt, field) {

    try {
      field.value.forEach(x => x.Show = evt.target.checked);
    } catch (e) {
      console.error(e);
    }

  }

  handleDocumentCategoryAllowUploadAllChange(evt, field) {

    try {
      field.value.forEach(r => r.AllowUpload = evt.target.checked);
    } catch (e) {
      console.error(e);
    }

  }

  additionalInfoAllowAllChecked(field) {
    return field.value.every(r => r.Allowed);
  }

  additionalInfoDefaultAllChecked(field) {
    return field.value.every(r => r.Default);
  }

  handleAdditionalInfoAllowAllChange(evt, field) {

    try {
      field.value.forEach(x => x.Allowed = evt.target.checked);
    } catch (e) {
      console.error(e);
    }

  }

  handleAdditionalInfoDefaultAllChange(evt, field) {

    try {
      field.value.forEach(r => r.Default = evt.target.checked);
    } catch (e) {
      console.error(e);
    }

  }
}
